import cn from 'classnames'
import React from 'react'
import { SHOW_COLLECTIONS_FOR_ALL } from 'src/config/config'

interface BlogHeaderProps {
  className?: string
  title?: string
}

/**
 * Primary UI component for user interaction
 */
export const BlogHeader: React.FC<BlogHeaderProps> = ({ className, title }) => {
  return (
    <div className={cn(className, 'flex flex-row justify-center bg-clouds')}>
      <div className="w-full">
        <div className={cn('flex flex-row sm:px-0 justify-center')}>
          <div
            className={cn(
              '!max-w-[1100px] w-full flex md:flex-row flex-col  md:pl-[0rem] pl-[1.25rem] pr-[1.25rem]',
              SHOW_COLLECTIONS_FOR_ALL == 'true'
                ? ' md:mt-[27px] text-[#333333] text-[30px]'
                : 'md:mt-[0.9375rem] py-2 text-[#222222] text-[1.5rem]',
            )}
          >
            <div className={cn('flex', 'flex-row', className)}>
              <h1
                className={cn(
                  'font-bold font-secondary ',
                  SHOW_COLLECTIONS_FOR_ALL == 'true'
                    ? 'text-[#333333] text-[30px]  py-[2.5px]'
                    : ' py-2 text-[#222222] text-[1.5rem]',
                )}
              >
                {title ? title : 'Industry Analysis'}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
